import { z } from 'zod'

export const RoleCreateSchema = z.object({
  name: z.string(),
})

export type RoleCreateModel = z.infer<typeof RoleCreateSchema>

export const RoleUpdateSchema = z.object({
  id: z.number(),
  name: z.string(),
})

export type RoleUpdateModel = z.infer<typeof RoleUpdateSchema>
